module.exports = __webpack_public_path__ + "img/trunk_10x3_z16.9e7db0d5.svg";